import React, { useState, useEffect, useRef } from "react";
import "./HistoryResponse.scss";
import HistoryAnswerDisplay from "./HistoryAnswerDisplay";
import Alert from "@mui/material/Alert";
import { Avatar } from "@mui/material";
import DisplayUserInput from "../response/DisplayUserInput";
import botImg from "../../app/assets/videos/Loading-gif.gif";
import PushPinIcon from "@mui/icons-material/PushPin";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import CachedIcon from "@mui/icons-material/Cached";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Link2Icon from "@mui/icons-material/Link";


const loadingMessages = [
  { text: "Understanding the questions...", delay: 2000 },
  { text: "Generating SQL...", delay: 2000 },
  { text: "Synthesizing the insights...", delay: 2000 },
  { text: "Preparing reports...", delay: 2000 },
];

const HistoryResponce = ({
  message,
  setIsLoading,
  isLoading,
  index,
  printPDF,
  loadingIndex,
  setResponceData,
  isHistory,
  page,
  newChatStart,
}) => {
  const [open, setOpen] = useState(false);
  const [loadingStep, setLoadingStep] = useState(0);
  const chatEndRef = useRef(null);
  const [isPinned, setIsPinned] = useState(
    (message && message?.response?.pin_response) || false
  );
  const [pinError, setPinError] = useState(false);
  const [pinSuccess, setPinSuccess] = useState(false);
  const [pinLoading, setPinLoading] = useState(false);
  const history = useHistory();
  const [expandedIndex, setExpandedIndex] = useState(0);

  const handlePin = async (messageId, child_question_id) => {
    let baseUrl = "";
    let data = null;
    try {
      if (!isPinned) {
        baseUrl = `${process.env.REACT_APP_BASE_URL}/aadi/pin`;
        data = {
          messageID: messageId,
          email: `${localStorage.getItem("userinfo")}`,
          child_question_id: child_question_id,
        };
      } else {
        baseUrl = `${process.env.REACT_APP_BASE_URL}/aadi/remove/pin`;
        data = {
          messageID: messageId,
          email: `${localStorage.getItem("userinfo")}`,
        };
      }
      setPinLoading(true);
    
      const response = await axios.post(baseUrl, data);

      if (response.status === 200) {
        setPinLoading(false);
        setPinSuccess(true);
        setTimeout(() => {
          setPinSuccess(false);
        }, 2000);
        setIsPinned((prevState) => !prevState);
      } else {
        console.error(
          "Error delete history data:",
          response.status,
          response.statusText
        );
        setPinLoading(false);
        setPinError(true);
        setTimeout(() => {
          setPinError(false);
        }, 2000);
      }
    } catch (error) {
      setPinLoading(false);
      console.error("Error delete history chat:", error);
      setPinError(true);
      setTimeout(() => {
        setPinError(false);
      }, 2000);
    }
  };

  const appendParamsToHomePage = (params) => {
    let currentUrl = new URL(window.location.origin);
    currentUrl.pathname = "/decisionIntelligence";

    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        currentUrl.searchParams.append(key, params[key]);
      }
    }

    history.replace({
      pathname: currentUrl.pathname,
      search: currentUrl.search,
    });
  };

  useEffect(() => {
    if (message?.response?.content?.length > 1) {
      setExpandedIndex(0);
    }
  }, [message?.response?.content]);
  

  useEffect(() => {
    if (isLoading && loadingStep < loadingMessages.length) {
      const timer = setTimeout(() => {
        setLoadingStep((prevState) => prevState + 1);
      }, loadingMessages[loadingStep].delay);

      return () => clearTimeout(timer);
    }
  }, [isLoading, loadingStep]);
  const isTab = useMediaQuery({ query: "(max-width: 768px)" });
  return (
    <>
      <div id={`message-${index}`} className={`query-container`}>
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <DisplayUserInput message={message?.response} />

          <div
            onClick={() => {
              let params = {
                historyQuery: message?.response.query,
              };

              appendParamsToHomePage(params);
            }}
            title="Re Ask"
            style={{ cursor: "pointer" }}
          >
            <CachedIcon />
          </div>
        </div>

        <div className="pt-4">
          <>
          
            {message?.response?.summary_of_summaries &&
              message?.response?.summary_of_summaries.toLowerCase() !== "na" &&
              message?.response?.summary_of_summaries.toLowerCase() !==
                "n/a" && (
                <>
                  <div className="summary-section">
                    {/* <h3>Overall Summary</h3> */}
                    <p>{message?.response?.summary_of_summaries}</p>
                  </div>
                  <span style={{borderRadius:"6px"}} className="supporting-txt p-2 mb-3 block bg-gradient-to-r from-[#1d64ac]/20 to-[#1d64ac]/70 font-bold">Supporting Facts</span>
                  </>
              )}
           <div className="main-card grid gap-4">
  {/* 🔹 MULTIPLE ITEMS → ACCORDION */}
  {Array.isArray(message?.response?.content) &&
    message.response.content.length > 1 &&
    message.response.content.map((item, idx) => (
      <Accordion
        key={item?.child_question_id || idx}
        expanded={expandedIndex === idx}
        onChange={() => setExpandedIndex(idx)}
        sx={{
          borderRadius: 2,
          boxShadow: "none",
          border: "1px solid #e0e0e0",
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <span className="font-semibold text-[#1d64ac] flex gap-2 items-center">
            <Link2Icon fontSize="small" />
            Question {idx + 1}: {item?.header || `Section ${idx + 1}`}
          </span>
        </AccordionSummary>

        <AccordionDetails>
          <HistoryAnswerDisplay
            item={item}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            responseId={message?.response?.message_id}
            setOpen={setOpen}
            open={open}
            index={item.child_question_id}
            responseNumber={message?.response?.content.length}
            isPinned={isPinned}
            pinError={pinError}
            handlePin={handlePin}
            message={message}
            pinLoading={pinLoading}
            messageData={message}
          />
        </AccordionDetails>
      </Accordion>
    ))}

  {/* 🔹 SINGLE ITEM → NORMAL VIEW */}
  {Array.isArray(message?.response?.content) &&
    message.response.content.length === 1 && (
      <>
        {message.response.content[0]?.header && (
          <div className="content-header mb-2 font-semibold text-[#1d64ac]">
            {message.response.content[0].header}
          </div>
        )}

        <HistoryAnswerDisplay
          item={message.response.content[0]}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          responseId={message?.response?.message_id}
          setOpen={setOpen}
          open={open}
          index={message.response.content[0]?.child_question_id}
          responseNumber={1}
          isPinned={isPinned}
          pinError={pinError}
          handlePin={handlePin}
          message={message}
          pinLoading={pinLoading}
          messageData={message}
        />
      </>
    )}
</div>

            <div className="pin-message">
              {pinError && (
                <Alert severity="error">
                  Something went wrong. please try again.
                </Alert>
              )}
              {pinSuccess && (
                <Alert severity="success">
                  {isPinned
                    ? "Response pinned successfully."
                    : "Response unpinned successfully."}
                </Alert>
              )}
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default HistoryResponce;
